import { IUpdateDiarioObraImagensUseCase } from "../../../presentation/useCases/update/update_diario_obras_imagens_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// UpdateDiarioObraImagensUseCase


export class UpdateDiarioObraImagensUseCase implements IUpdateDiarioObraImagensUseCase {
  constructor(private readonly repository: IDiarioObraRepository) { }

  async updateDiarioObraImagens(IdDiarioObrasImagens: number, IdDiarioObras: number | null, DescricaoImagem: string | null, Imagem: File | null, ExtensaoImagem: string | null, Nome: string | null, Ordem: number | null, LimparArquivo: boolean): Promise<void> {

    await this.repository.updateDiarioObraImagens(
      IdDiarioObrasImagens, IdDiarioObras, DescricaoImagem, Imagem, ExtensaoImagem, Nome, Ordem, LimparArquivo
    );
  }
}
